import { render, staticRenderFns } from "./EditBuildings.vue?vue&type=template&id=22e49877&scoped=true"
import script from "./EditBuildings.vue?vue&type=script&lang=js"
export * from "./EditBuildings.vue?vue&type=script&lang=js"
import style0 from "./EditBuildings.vue?vue&type=style&index=0&id=22e49877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e49877",
  null
  
)

export default component.exports